export default function(props, propName, componentName) {
  if (!/[^?#]+(\?[^?]+)?(#[^#?]+)?/.test(props[propName])) {
    return new Error(
      'Invalid prop `' + propName + '` supplied to' +
      ' `' + componentName + '`. Invalid path. Validation failed.'
    );
  }
}
